/**
 * TBM 입장 링크(유니버셜 링크/앱 링크) 수신
 * - 일반 카메라로 QR을 스캔했을 때 앱이 설치돼 있으면 OS가 앱을 열고 appUrlOpen으로 URL을 넘김
 * - 입장 토큰만 보관해 두고 홈에서 기존 회원 참석(saveTbmNewU2)을 이어서 처리
 *   (로그아웃 상태면 로그인 후 홈에 도달했을 때 처리)
 */
const PENDING_KEY = 'pendingTbmJoinToken';
export const TBM_JOIN_PENDING_EVENT = 'tbm-join-pending';

export const SetPendingTbmJoinToken = (token) => {
  try {
    sessionStorage.setItem(PENDING_KEY, token);
  } catch (e) {
    console.error(e);
  }
  window.dispatchEvent(new Event(TBM_JOIN_PENDING_EVENT));
};

/** 보관된 토큰을 꺼내고 지움 (없으면 '') */
export const TakePendingTbmJoinToken = () => {
  try {
    const token = sessionStorage.getItem(PENDING_KEY) || '';
    if (token) sessionStorage.removeItem(PENDING_KEY);
    return token;
  } catch (e) {
    return '';
  }
};
